// extracted by mini-css-extract-plugin
export default {"title":"SectionTitle_title"};